import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import DragPicker from 'components/picker/drag/drag_picker'
import MediaSearch from 'decorators/media_search/media_search_decorator'
import ImageSearch from 'components/picker/search/image/image_picker_search'
import CSESearch from 'components/picker/search/cse/CSESearch'
import NearpodPickerBottomBar from '../../components/bottom_bar/nearpod_picker_bottom_bar'
import NearpodPickerOptions from '../../components/options/nearpod_picker_options'
import { normalizeImageSearchFiles } from 'helpers/pickerNormalizer'
import imagesSearchSelector from 'redux/selectors/feature_flags/images_search_selector'
import { localize } from 'helpers/translator'

import styles from './nearpod_picker_image.scss'

class NearpodPickerImage extends PureComponent {

	constructor() {
		super()
		this.cancelHandler = this.cancelHandler.bind(this)
		this.saveHandler = this.saveHandler.bind(this)
	}

	cancelHandler() {
		if (this.props.imageSearchActive) {
			this.props.onMediaSearchClear('image')
		} else {
			this.props.closeHandler()
		}
	}

	saveHandler() {
		const selectedItems = this.props.imageSearchResults.filter((data, index) => this.props.imageSearchSelected.includes(index))
		this.props.onFilesPicked(normalizeImageSearchFiles(selectedItems, 'google'))
	}

	render() {
		return (
			<div styleName='wrapper'>
				<SecondaryTitle isCentered={true}>{localize('picker_image_title')}</SecondaryTitle>
				{ this.props.canUseCSESearch &&
					<CSESearch
						onSearchSelection={this.props.onMediaSearchSelection}
						onSearchChange={this.props.onMediaSearchChange}
						selected={this.props.imageSearchSelected}
						results={this.props.imageSearchResults}
						onResults={this.props.onMediaCSEResults}
						onSave={this.saveHandler}
					/>
				}
				{ !this.props.canUseCSESearch &&
					<ImageSearch
						onSearchConfirm={this.props.onMediaSearchConfirm}
						onSearchChange={this.props.onMediaSearchChange}
						onNextPageRequest={this.props.onMediaSearchNextPageRequest}
						onSearchSelection={this.props.onMediaSearchSelection}
						searchTextValue={this.props.imageSearchTextValue}
						results={this.props.imageSearchResults}
						active={this.props.imageSearchActive}
						selected={this.props.imageSearchSelected}
						showMore={this.props.imageShowMore}
						message={this.props.imageMessage}
						title={this.props.imageTitle}
						hint={this.props.imageHint}
						multiselect={this.props.multiselect}
						placeholder={localize('picker_image_search_placeholder')}
						source='google'
					/>
				}
				{!this.props.imageSearchActive &&
				<div styleName='file-selection'>
					<div styleName='drag-and-drop'>
						<DragPicker
							onChange={this.props.onFilesPicked}
							accept={this.props.accept}
							pickerType={this.props.pickerType}
							dropRejectedHandler={this.props.onFileError}
							multiselect={this.props.multiselect} />
					</div>
					<span styleName='source-options-or'>{localize('picker_connector_or')}</span>
					<NearpodPickerOptions
						onFilesPicked={this.props.onFilesPicked}
						onFileError={this.props.onFileError}
						multiselect={this.props.multiselect}
						accept={this.props.accept}
						googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
					/>
				</div>}
				<NearpodPickerBottomBar
					cancelText={this.props.imageSearchActive?localize('global_back'):localize('global_cancel')}
					cancelHandler={this.cancelHandler}
					saveHandler={this.saveHandler}
					saveButtonEnabled={!!this.props.imageSearchSelected.length} />
			</div>
		)
	}

}

NearpodPickerImage.defaultProps = {
	canUseCSESearch: true,
}

NearpodPickerImage.propTypes = {
	canUseCSESearch: PropTypes.bool,
}

function mapStateToProps(state) {
	return imagesSearchSelector(state)
}


export default connect(mapStateToProps, null)(MediaSearch(CSSModules(NearpodPickerImage, styles, {allowMultiple: true})))
